module.exports = __webpack_public_path__ + "static/media/how-it-works-1.c9b657c3.jpg";